import { Stack } from "@mui/material";
import AdminComponent from "../lib/bandung/components/Admin/AdminComponent";

const Admin = () => {
  return (
    <>
      <div className="login-page-wrapper w-full py-10">
        <div className="container-x mx-auto">
          <Stack
            alignItems="center"
            justifyContent="center"
            width="100%"
            margin="2em 0"
          >
            <AdminComponent/>
          </Stack>
        </div>
      </div>
    </>
  );
};

export default Admin;